import { BehaviorSubject } from 'rxjs';

export abstract class IAuthService {
  protected authenticationSubject = new BehaviorSubject<boolean>(false);
  public authentication$ = this.authenticationSubject.asObservable();

  abstract signIn(user: any): Promise<any>;
  abstract signOut(): Promise<any>;
  abstract isAuthenticated(): Promise<boolean>;
  abstract getUser(): Promise<any>;
}
